import { render, staticRenderFns } from "./MacchinaSelect.vue?vue&type=template&id=f2311446&"
import script from "./MacchinaSelect.vue?vue&type=script&lang=js&"
export * from "./MacchinaSelect.vue?vue&type=script&lang=js&"
import style0 from "./MacchinaSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SPRAYER_MANAGER/SPRAYER_MANAGER_SITO/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCombobox,VFlex,VLayout})
